import { gql, useApolloClient } from "@apollo/client";
import { StackApiContext, useSnackbarApi } from "@comet/admin";
import Snackbar from "@src/components/snackbar/Snackbar";
import { type GQLRemoveCameraAdminMutation, type GQLRemoveCameraAdminMutationVariables } from "@src/graphql.generated";
import { type ReactElement, useContext } from "react";
import { useIntl } from "react-intl";

import { type CommonDeleteDialogProps, DeleteDialog } from "./DeleteDialog";

const removeCameraAdmin = gql`
    mutation RemoveCameraAdmin($id: ID!) {
        removeCameraAdmin(id: $id)
    }
`;

interface DeleteDeviceDialogProps extends CommonDeleteDialogProps {
    cameraId: string;
}

const DeleteDeviceDialog = ({ cameraId, ...restProps }: DeleteDeviceDialogProps): ReactElement => {
    const client = useApolloClient();
    const stackApi = useContext(StackApiContext);
    const snackbarApi = useSnackbarApi();
    const intl = useIntl();

    const submit = async () => {
        await client.mutate<GQLRemoveCameraAdminMutation, GQLRemoveCameraAdminMutationVariables>({
            mutation: removeCameraAdmin,
            variables: { id: cameraId },
            refetchQueries: ["CamerasAdmin"],
        });
        stackApi?.goBack();

        snackbarApi.showSnackbar(
            <Snackbar
                variant="success"
                message={intl.formatMessage({
                    id: "reviermanager.camera.delete",
                    defaultMessage: "Kamera wurde gelöscht",
                })}
                key="reviermanager.camera.delete"
                handleClose={snackbarApi.hideSnackbar}
            />,
        );
    };

    return <DeleteDialog {...restProps} submit={submit} />;
};

export default DeleteDeviceDialog;
